import {Pipe, PipeTransform} from "@angular/core";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";

@Pipe({name: 'standard', pure: true, standalone: true})
export class StandardTekstPipe implements PipeTransform {
    constructor() {}

    transform(verdi: any, tekstDersomNil = '-'): string | null {
        if (erNil(verdi) || verdi === '' ) return tekstDersomNil;
        return verdi;
    }
}
